import { Box, CircularProgress } from "@mui/material";

export const Loading = () => {
  return (
    <Box >
      <CircularProgress sx={{ position: 'absolute', top: 'calc(50% - 18px)', left: 'calc(50% - 18px)', transform: 'translate(-50%, -50%)' }} />
    </Box>
  );
};